import React, { useRef, useState } from "react"
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import ReportHeader from "../component/report-header/ReportHeader";
import AHMIS, { API_URL } from "../../../api/api";
import { ERROR, REPORT_NOT_DRAWN, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";
import AddAlertMessage from "../../../components/alert/Alert";
import MessageBlock from "../../admin/components/message-block/MessageBlock";
import PatientCountCell from "../../../components/patient-count-cell/PatientCountCell";

const OutPatientReport = () => {

  const [tableData, setTableData] = useState();
  const printComponentRef = useRef();

  const getReportData = (dateFrom, dateTo) => {
    const url = `${API_URL.outPatientReport}?fromDate=${dateFrom}&toDate=${dateTo}`;
    AHMIS.get(url).then(response => {
      const jsondata = response.data;
      if (jsondata.type === SUCCESS) {
        setTableData(jsondata.data);
      } else {
        AddAlertMessage({ type: jsondata.type, message: jsondata.message });
      }
    }).catch(error => {
      AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
    });
  };

  return (
    <>
      <ReportHeader
        title="बहिरंग सेवा विवरण"
        getReportData={getReportData}
        reportData={Boolean(tableData)}
        printComponentRef={printComponentRef}
      />
      {tableData ? (
        <Box ref={printComponentRef}>
          <TableContainer>
            <Typography variant="body1" className="report-heading">७. बहिरंग सेवा विवरण</Typography>
            <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Out-Patient-Report">
              <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                <TableRow>
                  <TableCell> क्र.सं. </TableCell>
                  <TableCell>ICD11</TableCell>
                  <TableCell>रोग</TableCell>
                  <TableCell>महिला</TableCell>
                  <TableCell>पुरुष</TableCell>
                  <TableCell>अन्य</TableCell>
                </TableRow>
              </TableHead>
              <TableBody classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell>1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Jwar (Fever)</TableCell>
                  <PatientCountCell data={tableData["1"]?.FEMALE} />
                  <PatientCountCell data={tableData["1"]?.MALE} />
                  <PatientCountCell data={tableData["1"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Swash vikar (Respiratory disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>2.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Swash (Asthm and COAD)</TableCell>
                  <PatientCountCell data={tableData["2"]?.FEMALE} />
                  <PatientCountCell data={tableData["2"]?.MALE} />
                  <PatientCountCell data={tableData["2"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>2.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Kas (Coughing disorder)</TableCell>
                  <PatientCountCell data={tableData["3"]?.FEMALE} />
                  <PatientCountCell data={tableData["3"]?.MALE} />
                  <PatientCountCell data={tableData["3"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>2.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <PatientCountCell data={tableData["4"]?.FEMALE} />
                  <PatientCountCell data={tableData["4"]?.MALE} />
                  <PatientCountCell data={tableData["4"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Amlapitta (APD)</TableCell>
                  <PatientCountCell data={tableData["5"]?.FEMALE} />
                  <PatientCountCell data={tableData["5"]?.MALE} />
                  <PatientCountCell data={tableData["5"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Atisar/Grahani (Diarrhoea/IBS)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>4.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Atisar (Diarrhoea)</TableCell>
                  <PatientCountCell data={tableData["6"]?.FEMALE} />
                  <PatientCountCell data={tableData["6"]?.MALE} />
                  <PatientCountCell data={tableData["6"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>4.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Grahani (IBS,IBD,Ulcerative colitis, Crohn's disease, Sprue)</TableCell>
                  <PatientCountCell data={tableData["7"]?.FEMALE} />
                  <PatientCountCell data={tableData["7"]?.MALE} />
                  <PatientCountCell data={tableData["7"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>4.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Pravahika (Dysnetry)</TableCell>
                  <PatientCountCell data={tableData["8"]?.FEMALE} />
                  <PatientCountCell data={tableData["8"]?.MALE} />
                  <PatientCountCell data={tableData["8"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>4.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <PatientCountCell data={tableData["9"]?.FEMALE} />
                  <PatientCountCell data={tableData["9"]?.MALE} />
                  <PatientCountCell data={tableData["9"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>5</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Udarroga (Abdominal disorder)</TableCell>
                  <PatientCountCell data={tableData["10"]?.FEMALE} />
                  <PatientCountCell data={tableData["10"]?.MALE} />
                  <PatientCountCell data={tableData["10"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>6</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Prameha/Madhumeha</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>6.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Prameha</TableCell>
                  <PatientCountCell data={tableData["11"]?.FEMALE} />
                  <PatientCountCell data={tableData["11"]?.MALE} />
                  <PatientCountCell data={tableData["11"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>6.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Madhumeha (Diabetes mellitus)</TableCell>
                  <PatientCountCell data={tableData["12"]?.FEMALE} />
                  <PatientCountCell data={tableData["12"]?.MALE} />
                  <PatientCountCell data={tableData["12"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>7</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Kamala</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>7.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Kosthashrita kamala (Non obstructive jaundice)</TableCell>
                  <PatientCountCell data={tableData["13"]?.FEMALE} />
                  <PatientCountCell data={tableData["13"]?.MALE} />
                  <PatientCountCell data={tableData["13"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>7.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Shakhashrita kamala (Obstructive jaundice)</TableCell>
                  <PatientCountCell data={tableData["14"]?.FEMALE} />
                  <PatientCountCell data={tableData["14"]?.MALE} />
                  <PatientCountCell data={tableData["14"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>8</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Pandu (Anaemia)</TableCell>
                  <PatientCountCell data={tableData["15"]?.FEMALE} />
                  <PatientCountCell data={tableData["15"]?.MALE} />
                  <PatientCountCell data={tableData["15"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>9</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Hridaya roga (Cardiac disorder)</TableCell>
                  <PatientCountCell data={tableData["16"]?.FEMALE} />
                  <PatientCountCell data={tableData["16"]?.MALE} />
                  <PatientCountCell data={tableData["16"]?.OTHER} />

                </TableRow>
                <TableRow>
                  <TableCell>10</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Raktachap (Blood pressure disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>10.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Uchharaktachap (Hypertension)</TableCell>
                  <PatientCountCell data={tableData["17"]?.FEMALE} />
                  <PatientCountCell data={tableData["17"]?.MALE} />
                  <PatientCountCell data={tableData["17"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>10.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Nyunaraktachap (Hypotension)</TableCell>
                  <PatientCountCell data={tableData["18"]?.FEMALE} />
                  <PatientCountCell data={tableData["18"]?.MALE} />
                  <PatientCountCell data={tableData["18"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>11</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Shotha (Oedema)</TableCell>
                  <PatientCountCell data={tableData["19"]?.FEMALE} />
                  <PatientCountCell data={tableData["19"]?.MALE} />
                  <PatientCountCell data={tableData["19"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>12</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Krimi (Worm infestation)</TableCell>
                  <PatientCountCell data={tableData["20"]?.FEMALE} />
                  <PatientCountCell data={tableData["20"]?.MALE} />
                  <PatientCountCell data={tableData["20"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>13</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Twak vikar (Skin disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>13.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Ekkustha/Kitibha (Psoriasis)</TableCell>
                  <PatientCountCell data={tableData["21"]?.FEMALE} />
                  <PatientCountCell data={tableData["21"]?.MALE} />
                  <PatientCountCell data={tableData["21"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>13.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Pama </TableCell>
                  <PatientCountCell data={tableData["22"]?.FEMALE} />
                  <PatientCountCell data={tableData["22"]?.MALE} />
                  <PatientCountCell data={tableData["22"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>13.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Vyanga/Nyachha (Blemishes)</TableCell>
                  <PatientCountCell data={tableData["23"]?.FEMALE} />
                  <PatientCountCell data={tableData["23"]?.MALE} />
                  <PatientCountCell data={tableData["23"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>13.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell> Others</TableCell>
                  <PatientCountCell data={tableData["24"]?.FEMALE} />
                  <PatientCountCell data={tableData["24"]?.MALE} />
                  <PatientCountCell data={tableData["24"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>14</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Vrana (Wound/ulcer)</TableCell>
                  <PatientCountCell data={tableData["25"]?.FEMALE} />
                  <PatientCountCell data={tableData["25"]?.MALE} />
                  <PatientCountCell data={tableData["25"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>15</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Abhighataj vikar (Traumatic disorder)</TableCell>
                  <PatientCountCell data={tableData["26"]?.FEMALE} />
                  <PatientCountCell data={tableData["26"]?.MALE} />
                  <PatientCountCell data={tableData["26"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>16</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Vata vyadhi (Skeleto-muscular and nervous system disease)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Manyastambha (Torticollis)</TableCell>
                  <PatientCountCell data={tableData["27"]?.FEMALE} />
                  <PatientCountCell data={tableData["27"]?.MALE} />
                  <PatientCountCell data={tableData["27"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>16.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Avabahuka (Frozen shoulder)</TableCell>
                  <PatientCountCell data={tableData["28"]?.FEMALE} />
                  <PatientCountCell data={tableData["28"]?.MALE} />
                  <PatientCountCell data={tableData["28"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>16.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Vishwachi (Cervical spodylosis)</TableCell>
                  <PatientCountCell data={tableData["29"]?.FEMALE} />
                  <PatientCountCell data={tableData["29"]?.MALE} />
                  <PatientCountCell data={tableData["29"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>16.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Katishula (Lumbago)</TableCell>
                  <PatientCountCell data={tableData["30"]?.FEMALE} />
                  <PatientCountCell data={tableData["30"]?.MALE} />
                  <PatientCountCell data={tableData["30"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>16.5</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Gridhasi (Sciatica)</TableCell>
                  <PatientCountCell data={tableData["31"]?.FEMALE} />
                  <PatientCountCell data={tableData["31"]?.MALE} />
                  <PatientCountCell data={tableData["31"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>16.6</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Sandhivata (Osteoarthritis)</TableCell>
                  <PatientCountCell data={tableData["32"]?.FEMALE} />
                  <PatientCountCell data={tableData["32"]?.MALE} />
                  <PatientCountCell data={tableData["32"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>16.7</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Angamarda (Bodyache)</TableCell>
                  <PatientCountCell data={tableData["33"]?.FEMALE} />
                  <PatientCountCell data={tableData["33"]?.MALE} />
                  <PatientCountCell data={tableData["33"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>16.8</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Pakshaghat (Paralysis)</TableCell>
                  <PatientCountCell data={tableData["34"]?.FEMALE} />
                  <PatientCountCell data={tableData["34"]?.MALE} />
                  <PatientCountCell data={tableData["34"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>16.9</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Kampavata (Parkinson)</TableCell>
                  <PatientCountCell data={tableData["35"]?.FEMALE} />
                  <PatientCountCell data={tableData["35"]?.MALE} />
                  <PatientCountCell data={tableData["35"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>16.10</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Mamsagata vata (Muscular dystrophy)</TableCell>
                  <PatientCountCell data={tableData["36"]?.FEMALE} />
                  <PatientCountCell data={tableData["36"]?.MALE} />
                  <PatientCountCell data={tableData["36"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>16.11</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <PatientCountCell data={tableData["37"]?.FEMALE} />
                  <PatientCountCell data={tableData["37"]?.MALE} />
                  <PatientCountCell data={tableData["37"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>17</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Amavata (Rheumatoid arthritis)</TableCell>
                  <PatientCountCell data={tableData["38"]?.FEMALE} />
                  <PatientCountCell data={tableData["38"]?.MALE} />
                  <PatientCountCell data={tableData["38"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>18</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Vatrakta (Gout)</TableCell>
                  <PatientCountCell data={tableData["39"]?.FEMALE} />
                  <PatientCountCell data={tableData["39"]?.MALE} />
                  <PatientCountCell data={tableData["39"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>19</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Raktavikar (Blood disorder)</TableCell>
                  <PatientCountCell data={tableData["40"]?.FEMALE} />
                  <PatientCountCell data={tableData["40"]?.MALE} />
                  <PatientCountCell data={tableData["40"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>20</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Mutravikar (Urinary disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>20.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Mutrasmari (Renal calculi)</TableCell>
                  <PatientCountCell data={tableData["41"]?.FEMALE} />
                  <PatientCountCell data={tableData["41"]?.MALE} />
                  <PatientCountCell data={tableData["41"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>20.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Mutrakrichhra (Dysuria)</TableCell>
                  <PatientCountCell data={tableData["42"]?.FEMALE} />
                  <PatientCountCell data={tableData["42"]?.MALE} />
                  <PatientCountCell data={tableData["42"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>20.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Mutraghat (Retnetion/suppression of urine)</TableCell>
                  <PatientCountCell data={tableData["43"]?.FEMALE} />
                  <PatientCountCell data={tableData["43"]?.MALE} />
                  <PatientCountCell data={tableData["43"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>21</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Prasutivikar (Postpartum disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>21.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Stanya vikar (Breast milk dosorder)</TableCell>
                  <PatientCountCell data={tableData["44"]?.FEMALE} />
                  <PatientCountCell data={tableData["44"]?.MALE} />
                  <PatientCountCell data={tableData["44"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>21.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Garbhashayachhyuta (Uterine prolapse)</TableCell>
                  <PatientCountCell data={tableData["45"]?.FEMALE} />
                  <PatientCountCell data={tableData["45"]?.MALE} />
                  <PatientCountCell data={tableData["45"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>21.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <PatientCountCell data={tableData["46"]?.FEMALE} />
                  <PatientCountCell data={tableData["46"]?.MALE} />
                  <PatientCountCell data={tableData["46"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>22</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Striroga (Gynaecological disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>22.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Raktapradar (Menstrual problem)</TableCell>
                  <PatientCountCell data={tableData["47"]?.FEMALE} />
                  <PatientCountCell data={tableData["47"]?.MALE} />
                  <PatientCountCell data={tableData["47"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>22.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Swetapradar (Leucorrhoea)</TableCell>
                  <PatientCountCell data={tableData["48"]?.FEMALE} />
                  <PatientCountCell data={tableData["48"]?.MALE} />
                  <PatientCountCell data={tableData["48"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>22.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Kashtartawa (Dysmenorrhoea)</TableCell>
                  <PatientCountCell data={tableData["49"]?.FEMALE} />
                  <PatientCountCell data={tableData["49"]?.MALE} />
                  <PatientCountCell data={tableData["49"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>22.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Anartawa (Amenorrhoea)</TableCell>
                  <PatientCountCell data={tableData["50"]?.FEMALE} />
                  <PatientCountCell data={tableData["50"]?.MALE} />
                  <PatientCountCell data={tableData["50"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>22.5</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Yoniroga</TableCell>
                  <PatientCountCell data={tableData["51"]?.FEMALE} />
                  <PatientCountCell data={tableData["51"]?.MALE} />
                  <PatientCountCell data={tableData["51"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>22.6</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <PatientCountCell data={tableData["52"]?.FEMALE} />
                  <PatientCountCell data={tableData["52"]?.MALE} />
                  <PatientCountCell data={tableData["52"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>23</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Gudavikar</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>23.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Arsha (Haemorrhoids)</TableCell>
                  <PatientCountCell data={tableData["53"]?.FEMALE} />
                  <PatientCountCell data={tableData["53"]?.MALE} />
                  <PatientCountCell data={tableData["53"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>23.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Bhagandar (Fistula in ano)</TableCell>
                  <PatientCountCell data={tableData["54"]?.FEMALE} />
                  <PatientCountCell data={tableData["54"]?.MALE} />
                  <PatientCountCell data={tableData["54"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>23.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Pilonidal sinus</TableCell>
                  <PatientCountCell data={tableData["55"]?.FEMALE} />
                  <PatientCountCell data={tableData["55"]?.MALE} />
                  <PatientCountCell data={tableData["55"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>23.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Perianal wart</TableCell>
                  <PatientCountCell data={tableData["56"]?.FEMALE} />
                  <PatientCountCell data={tableData["56"]?.MALE} />
                  <PatientCountCell data={tableData["56"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>23.5</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Parikartika (Fissure)</TableCell>
                  <PatientCountCell data={tableData["57"]?.FEMALE} />
                  <PatientCountCell data={tableData["57"]?.MALE} />
                  <PatientCountCell data={tableData["57"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>23.6</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <PatientCountCell data={tableData["58"]?.FEMALE} />
                  <PatientCountCell data={tableData["58"]?.MALE} />
                  <PatientCountCell data={tableData["58"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>24</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Netraroga (Ophthamological disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>24.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Abhisyandi (Conjunctivitis)</TableCell>
                  <PatientCountCell data={tableData["59"]?.FEMALE} />
                  <PatientCountCell data={tableData["59"]?.MALE} />
                  <PatientCountCell data={tableData["59"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>24.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Athimantha (Glaucoma)</TableCell>
                  <PatientCountCell data={tableData["60"]?.FEMALE} />
                  <PatientCountCell data={tableData["60"]?.MALE} />
                  <PatientCountCell data={tableData["60"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>24.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Timira (Cataract)</TableCell>
                  <PatientCountCell data={tableData["61"]?.FEMALE} />
                  <PatientCountCell data={tableData["61"]?.MALE} />
                  <PatientCountCell data={tableData["61"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>24.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <PatientCountCell data={tableData["62"]?.FEMALE} />
                  <PatientCountCell data={tableData["62"]?.MALE} />
                  <PatientCountCell data={tableData["62"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>25</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Karna-nasa-mukha-danta-kantha roga</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>25.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Karna roga (Disease related to ear)</TableCell>
                  <PatientCountCell data={tableData["63"]?.FEMALE} />
                  <PatientCountCell data={tableData["63"]?.MALE} />
                  <PatientCountCell data={tableData["63"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>25.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Nasa roga (Disease related to nose)</TableCell>
                  <PatientCountCell data={tableData["64"]?.FEMALE} />
                  <PatientCountCell data={tableData["64"]?.MALE} />
                  <PatientCountCell data={tableData["64"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>24</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Mukha roga (Oral disease)</TableCell>
                  <PatientCountCell data={tableData["65"]?.FEMALE} />
                  <PatientCountCell data={tableData["65"]?.MALE} />
                  <PatientCountCell data={tableData["65"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>25.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Danta roga(Dental disease)</TableCell>
                  <PatientCountCell data={tableData["66"]?.FEMALE} />
                  <PatientCountCell data={tableData["66"]?.MALE} />
                  <PatientCountCell data={tableData["66"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>25.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Kantha roga (Disease related to throat)</TableCell>
                  <PatientCountCell data={tableData["67"]?.FEMALE} />
                  <PatientCountCell data={tableData["67"]?.MALE} />
                  <PatientCountCell data={tableData["67"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>26</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Shiroroga (Disease related to head)</TableCell>
                  <PatientCountCell data={tableData["68"]?.FEMALE} />
                  <PatientCountCell data={tableData["68"]?.MALE} />
                  <PatientCountCell data={tableData["68"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>27</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Manasvikar (Psychological disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>27.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Apasmar (Epilepsy)</TableCell>
                  <PatientCountCell data={tableData["69"]?.FEMALE} />
                  <PatientCountCell data={tableData["69"]?.MALE} />
                  <PatientCountCell data={tableData["69"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>27.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Unmad (Neurosis)</TableCell>
                  <PatientCountCell data={tableData["70"]?.FEMALE} />
                  <PatientCountCell data={tableData["70"]?.MALE} />
                  <PatientCountCell data={tableData["70"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>27.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Atatwavinesh (Psychosis)</TableCell>
                  <PatientCountCell data={tableData["71"]?.FEMALE} />
                  <PatientCountCell data={tableData["71"]?.MALE} />
                  <PatientCountCell data={tableData["71"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>27.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <PatientCountCell data={tableData["72"]?.FEMALE} />
                  <PatientCountCell data={tableData["72"]?.MALE} />
                  <PatientCountCell data={tableData["72"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>28</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Balroga (Paediatric disorder)</TableCell>
                  <PatientCountCell data={tableData["73"]?.FEMALE} />
                  <PatientCountCell data={tableData["73"]?.MALE} />
                  <PatientCountCell data={tableData["73"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>29</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Jarajanya vikar (Geriatric problem)</TableCell>
                  <PatientCountCell data={tableData["74"]?.FEMALE} />
                  <PatientCountCell data={tableData["74"]?.MALE} />
                  <PatientCountCell data={tableData["74"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>30</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Anya/vividha</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>30.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Granthi/Arbuda roga (Tumor/cancer)</TableCell>
                  <PatientCountCell data={tableData["75"]?.FEMALE} />
                  <PatientCountCell data={tableData["75"]?.MALE} />
                  <PatientCountCell data={tableData["75"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>30.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Antashrabi granthi janya roga (Hormonal disorder) </TableCell>
                  <PatientCountCell data={tableData["76"]?.FEMALE} />
                  <PatientCountCell data={tableData["76"]?.MALE} />
                  <PatientCountCell data={tableData["76"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell>30.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <PatientCountCell data={tableData["77"]?.FEMALE} />
                  <PatientCountCell data={tableData["77"]?.MALE} />
                  <PatientCountCell data={tableData["77"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell colSpan={3}>नयाँ सेवाग्राही जम्मा</TableCell>
                  <PatientCountCell data={tableData["NEW_PATIENT"]?.FEMALE} />
                  <PatientCountCell data={tableData["NEW_PATIENT"]?.MALE} />
                  <PatientCountCell data={tableData["NEW_PATIENT"]?.OTHER} />
                </TableRow>
                <TableRow>
                  <TableCell colSpan={3}>दोहोरिएको सेवाग्राही जम्मा</TableCell>
                  <PatientCountCell data={tableData["PREVIOUS_PATIENT"]?.FEMALE} />
                  <PatientCountCell data={tableData["PREVIOUS_PATIENT"]?.MALE} />
                  <PatientCountCell data={tableData["PREVIOUS_PATIENT"]?.OTHER} />
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <MessageBlock text={REPORT_NOT_DRAWN} />
      )}
    </>
  )
}

export default OutPatientReport;